// Sanzzy Map Config

export const mapStyle = [
  {
    featureType: "all",
    elementType: "all",
    stylers: [
      {
        saturation: -100,
      },
      {
        gamma: 0.5,
      },
    ],
  },
  {
    featureType: "water",
    elementType: "all",
    stylers: [
      {
        color: "#337ab7",
      },
      {
        visibility: "on",
      },
    ],
  },
];
